module.exports = __webpack_public_path__ + "static/earthquake-damage-2c00d3d2a10739a6b39d122a29f11dc9.jpg";